import {
  parseDate, set, compact, presence,
} from '@imcc/utilities';

function transformDate(value, transform) {
  const date = parseDate(value);

  if (date) return transform(value);

  return undefined;
}

export function createDateRangeReducer(property, transform) {
  return (state, action) => {
    const { term, [property]: value } = action;
    const tab = state.tabs[state.indexName];
    const date = transformDate(value, transform);
    const range = compact({ ...tab.active[term], [property]: date });

    return set(
      state,
      ['tabs', state.indexName, 'active', term],
      presence(range),
    );
  };
}
